
import { defineComponent, PropType, computed } from 'vue';

import { QuestionDto, QuestionDtoOption } from '@/types';

import {
  value2label,
  QUESTION_TYPE,
  numberToLetter,
  IS_QUESTION_TYPE_MULTI_CHOICE,
} from '@/utils';

import Image from './Image.vue';
import CustomAudio from './CustomAudio.vue';

export default defineComponent({
  name: 'QuestionChoice',
  components: {
    Image,
    CustomAudio,
  },
  props: {
    question: {
      type: Object as PropType<QuestionDto>,
      default: () => ({}),
    },
    answerMode: {
      type: Boolean,
      default: false,
    },
    currentPaperAnswer: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const onOptionCheck = (index: number, option: QuestionDtoOption) => {
      if (props.answerMode) return;

      let answer = '';
      const question = props.question;
      if (IS_QUESTION_TYPE_MULTI_CHOICE(question.questionTypeId)) {
        option.checked = option.checked ? '' : 'checked';
        answer = question.options
          .map((o, i) => ({ letter: numberToLetter(i), checked: o.checked }))
          .filter(o => o.checked)
          .map(o => o.letter)
          .join(',');
      } else {
        question.options.forEach(o => (o.checked = ''));
        option.checked = 'checked';
        answer = numberToLetter(index);
      }

      emit('change', answer, question);
    };

    const isUserAnswerRight = computed(() => {
      return props.question.questionStatus === 'success';
    });

    return {
      value2label,
      QUESTION_TYPE,
      numberToLetter,
      onOptionCheck,
      isUserAnswerRight,
    };
  },
});
